import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation, useNavigate } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { avantSolarApi } from "api/authApi";
import { useSelector } from "react-redux";
import Alert from "components/alert";
import ChangePassWordModal from "components/utils/changePassModal";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";

var ps;

function ListadoClientes(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [clientes, setClientes] = useState();
  const [clientesCopy, setClientesCopy] = useState();
  const navigate = useNavigate();
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [modal, setModal] = useState(false);
  const [userPassword, setUserPassword] = useState(null);
  const [loading, setLoading] = useState(false);
  const fetchClientes = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/all/allClients?id_huerta=" + huerta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      if (data?.code == 200) {
        setClientes([...data.data]);
        setClientesCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };
  useEffect(() => {
    fetchClientes();
  }, [huerta]);

  useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  }, []);

  useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleModal = () => {
    setModal(!modal);
  };

  const headers = [
    ["Titular", "Instalación", "Potencia", "Usuario", "Contraseña"],
  ];
  const headersTable = [
    { name: "Titular", prop: "titular" },
    { name: "Instalación", prop: "instalacion" },
    { name: `Potencia`, prop: "potencia" },
    { name: "Usuario", prop: "usuario" },
    { name: "Contraseña", prop: "usuario" },
  ];

  const properties = [
    "titular",
    "instalacion",
    "potencia",
    "usuario",
    "contraseña",
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          {!error && (
            <>
              <DataTableAvantSolar
                data={clientes}
                dataCopy={clientesCopy}
                setData={setClientes}
                titleProps={
                  "Listado de Clientes - Huerta: " +
                  obtenerNombreHuertaId(huerta)
                }
                headers={headers}
                headersTable={headersTable}
                name={"listadoClientes"}
                properties={properties}
                filtros={["instalacion", "titular"]}
                placeholderInput={"Filtra por Titular o Instalación"}
                defaultMostrar={40}
                setUserPassword={setUserPassword}
                toggleModal={toggleModal}
                loading={loading}
                clientes={true}
              ></DataTableAvantSolar>{" "}
              <Tooltip id="my-tooltip" />
            </>
          )}

          {error && <Alert message={error} />}
        </div>
        <Footer />
      </div>
      <ChangePassWordModal
        modal={modal}
        toggleModal={toggleModal}
        idUser={userPassword}
      ></ChangePassWordModal>
    </div>
  );
}

export default ListadoClientes;
